import * as React from "react";

const SvgIconNotes = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            fill="#606B85"
            fillRule="evenodd"
            d="M13.5 1a.5.5 0 0 0-1 0v1h-2V1a.5.5 0 0 0-1 0v1h-2V1a.5.5 0 0 0-1 0v1h-3A1.5 1.5 0 0 0 2 3.5v13A1.5 1.5 0 0 0 3.5 18h13a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 16.5 2h-3V1Zm-4 2h-2v1a.5.5 0 0 1-1 0V3h-3a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5h-3v1a.5.5 0 0 1-1 0V3h-2v1a.5.5 0 0 1-1 0V3Z"
            clipRule="evenodd"
        />
        <path
            fill="#606B85"
            d="M5 7.5a.5.5 0 0 1 .5-.5h9a.498.498 0 0 1 .45.717.5.5 0 0 1-.45.283h-9a.5.5 0 0 1-.5-.5Zm.5 2.5a.498.498 0 0 0-.49.6.5.5 0 0 0 .49.4h9a.5.5 0 1 0 0-1h-9Zm-.195 3.04A.498.498 0 0 1 5.5 13h6a.498.498 0 0 1 .481.636.5.5 0 0 1-.481.364h-6a.498.498 0 0 1-.458-.7.502.502 0 0 1 .263-.26Z"
        />
    </svg>
);

export default SvgIconNotes;
